"use client";
import React from "react";
import { motion } from "framer-motion";

export const Boxes = ({ 
  className = "", 
  boxClassName = "bg-blue-500/20",
  ...rest 
}) => {
  const rows = 8;
  const cols = 12;
  
  // Generate box grid with default positioning
  const points = React.useMemo(() => {
    const points = [];
    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        const x = j * (1 / cols) * 100;
        const y = i * (1 / rows) * 100;
        const delay = (Math.random() * 0.5);
        points.push({
          x,
          y,
          delay
        });
      }
    }
    return points;
  }, [rows, cols]);

  const boxVariants = {
    initial: {
      scale: 0,
      opacity: 0
    },
    animate: (delay) => ({
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.35,
        delay: delay
      }
    })
  };

  const containerVariants = {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };

  return (
    <div
      className={`absolute inset-0 flex items-center justify-center ${className}`}
      {...rest}
    >
      <motion.div
        className="absolute inset-0"
        variants={containerVariants}
        initial="initial"
        animate="animate"
      >
        {points.map((point, idx) => (
          <motion.div
            key={`box-${idx}`}
            className={`absolute top-0 left-0 w-8 h-8 rounded-lg ${boxClassName}`}
            style={{
              top: `${point.y}%`,
              left: `${point.x}%`,
              transform: `translate(-50%, -50%)`,
            }}
            variants={boxVariants}
            custom={point.delay}
          />
        ))}
      </motion.div>
    </div>
  );
};